import React, { useEffect, useState } from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import Direccion from '../direccion/Direccion';
import { Redirect } from "react-router-dom";
import { ValidarLogin } from '../../util';
import { logOut, getEmisor, postEmisor, clearErrors } from '../../actions';
import Profile from '../profile/profile';
import BasicMessage from '../messages/basicMessage';
import { messageTypeEnum } from '../../enum';
import { Accordion, Icon } from 'semantic-ui-react';
import ActividadEconomica from './actividadEconomica';
import Sucursales from '../sucursales/sucursales';


const Emisor = (props) => {
  const { token } = ValidarLogin(props);
  const [emisor, setEmisor] = useState(null);
  const { initialValues, errorState } = props;
  const [mgType, setMgType] = useState('');
  const [message, setMessage] = useState('');
  const [activeIndex, setActiveIndex] = useState(0);

  const handleClick = (e, titleProps) => {
    const { index } = titleProps
    const newIndex = activeIndex === index ? -1 : index

    setActiveIndex(newIndex);
  }

  useEffect(() => {
    props.clearErrors();
    if (initialValues === null && token !== null) {

      props.getEmisor(token.access_token, token.userName);

    }
  }, []);

  useEffect(() => {
    if (initialValues) {
      setEmisor({ ...initialValues });
    }

  }, [initialValues]);

  useEffect(() => {
    if (errorState && errorState.error !== null) {
      setMgType(errorState?.error ? messageTypeEnum.error : messageTypeEnum.success);
      setMessage(errorState.message);
    }
    else {
      setMgType('');
    }
  }, [errorState]);

  if (token === null) {
    return <Redirect to='/login' />;
  }
  const onSubmit = (formValues) => {
    props.postEmisor(token.access_token, formValues);
    setMgType('');
  }

  const closeMessage = () => {
    props.clearErrors();
  }

  const renderContactForm = () => {
    return (
      <>
        <form
          className="ui form"
          onSubmit={props.handleSubmit(onSubmit)}>
          <Profile />
          <Direccion token={token.access_token} Ubicacion={emisor.Ubicacion} />
          <div className="ui right aligned grid">
            <div className="sixteen wide column">
              <button className="ui button primary">Guardar</button>
            </div>
          </div>
        </form>
        <BasicMessage message={message} type={mgType} onClick={() => closeMessage()} />
      </>
    );
  };

  return (
    <>
      <div className="ui">
        <div className="ui right aligned grid">
          <div className="column">
            <span className="ui green tag label">
              <h3>EMISOR</h3>
            </span>
          </div>
        </div>
        {emisor && <div className="emisor-section">
          <Accordion fluid styled>
            <Accordion.Title
              active={activeIndex === 0}
              index={0}
              onClick={handleClick}
            >
              <Icon name='dropdown' />
              <span>Información de contacto</span>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 0}>
              {renderContactForm()}
            </Accordion.Content>
            <Accordion.Title
              active={activeIndex === 1}
              index={1}
              onClick={handleClick}
            >
              <Icon name='dropdown' />
              <span>Actividades económincas</span>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 1}>
              <ActividadEconomica
                token={token.access_token}
                cedula={emisor.Identificacion.Numero}
                emisorId={emisor.Id}
              />
            </Accordion.Content>
            <Accordion.Title
              active={activeIndex === 2}
              index={2}
              onClick={handleClick}
            >
              <Icon name='dropdown' />
              <span>Sucursales</span>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 2}>
              <Sucursales sucursales={emisor.Sucursales} />
            </Accordion.Content>
          </Accordion>
        </div>}
      </div>
    </>
  )
};

const validate = (formValues) => {
  const errors = {};

  if (!formValues.Nombre) {
    errors.Nombre = 'Debe ingresar el nombre';
  }

  if (!formValues?.Identificacion?.Numero) {
    errors.Identificacion = { Numero: 'Debe ingresa la cédula' };
  }
  else {

    switch (formValues.Identificacion.Tipo) {
      case '01':
        if (formValues.Identificacion.Numero.length !== 9) {
          errors.Identificacion = { Numero: 'Cédula física con formato incorrecto' };
        }
        break;
      case '02':
        if (formValues.Identificacion.Numero.length !== 10) {
          errors.Identificacion = { Numero: 'Cédula jurídica con formato incorrecto' };
        }
        break;
      case '03':
        if (formValues.Identificacion.Numero.length !== 12) {
          errors.Identificacion = { Numero: 'Cédula jurídica con formato incorrecto' };
        }
        break;
      default:
        break;
    }

    if (!formValues.CorreoElectronico) {
      errors.CorreoElectronico = 'Debe ingresar el email';
    }

    if (!formValues.Telefono.NumTelefono) {
      errors.CorreoElectronico = 'Debe ingresar el email';
    }

    if (!formValues.NombreLogo) {
      errors.NombreLogo = 'Debe ingresar el NombreLogo';
    }
  }

  return errors;
}

const formWrapperd = reduxForm({
  form: 'EmisorForm',
  enableReinitialize: true,
  validate
})(Emisor);

const mapStateToProps = (state) => {
  return {
    loginState: state.loginState,
    initialValues: state.emisorState !== null ? state.emisorState.emisor : null,
    errorState: state.errorState,
  };
}

export default connect(mapStateToProps, { logOut, getEmisor, postEmisor, clearErrors })(formWrapperd);